import React, { useState } from 'react';
import { Container, PageHeader, Tab, Tabs } from '@/components/ui';
import { usePermissions } from '../../../hooks/usePermissions';
import MessageBoardAudit from '../components/MessageBoardAudit';
import MessageBoardComposer from '../components/MessageBoardComposer';
import MessageBoardFilters from '../components/MessageBoardFilters';
import MessageBoardList from '../components/MessageBoardList';
import { useMessageBoardFeed } from '../hooks/useMessageBoardFeed';

const MessageBoardPage: React.FC = () => {
  const [refreshToken, setRefreshToken] = useState(0);
  const feed = useMessageBoardFeed(refreshToken);
  const { hasPermission } = usePermissions();
  const canModerate = hasPermission('message_board:moderate');
  const refresh = () => setRefreshToken((n) => n + 1);

  const sent = <MessageBoardList feed={feed} onRemoved={refresh} />;

  const feedPanel = canModerate ? (
    <Tabs
      defaultActiveKey="sent"
      id="message-center-tabs"
      className="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col"
      panelClassName="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col"
    >
      <Tab eventKey="sent" title="Sent">
        {sent}
      </Tab>
      <Tab eventKey="deleted" title="Deleted">
        <MessageBoardAudit feed={feed} refreshToken={refreshToken} />
      </Tab>
    </Tabs>
  ) : (
    sent
  );

  return (
    <Container className="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-overflow-hidden tw-py-4">
      <PageHeader
        className="tw-shrink-0"
        title="Message Center"
        subtitle="Send a notification to a foreman area, a service area, or people in your area."
      />
      <div className="tw-grid tw-min-h-0 tw-flex-1 tw-grid-cols-1 tw-grid-rows-[minmax(0,1.15fr)_minmax(0,1fr)] tw-gap-4 lg:tw-grid-cols-[minmax(0,1fr)_22rem] lg:tw-grid-rows-[minmax(0,1fr)] xl:tw-grid-cols-[minmax(0,1fr)_26rem]">
        <div className="tw-min-h-0 tw-min-w-0 tw-overflow-y-auto">
          <MessageBoardComposer onPosted={refresh} />
        </div>
        <aside className="tw-flex tw-min-h-0 tw-min-w-0 tw-flex-col tw-gap-4 tw-overflow-hidden">
          <div className="tw-shrink-0">
            <MessageBoardFilters feed={feed} />
          </div>
          <div className="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col">{feedPanel}</div>
        </aside>
      </div>
    </Container>
  );
};

export default MessageBoardPage;
